// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"674":"component---src-pages-markdown-remark-frontmatter-path-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"674":"0c5bd3e7afe02f56b415","678":"36b82dbb7d96e43831f1"}[chunkId] + ".js";
};